document.addEventListener("DOMContentLoaded", function () {
  	const employeeProfileForm= document.querySelector(".employee-profile-form");
  	if(employeeProfileForm){

		const addQualificationBtn = document.getElementById("add-new-qualifiaction");
		const qualificationSection = document.querySelector(".add-new-qualification");
		const qualificationGroup = document.querySelector(".form-element-group.my-qualifications");
	
		// Target the "Add new qualification" button inside the input section
		const inlineAddButton = qualificationSection.querySelector(".btn-add-new-qualification");
  
		// Toggle input section
		addQualificationBtn?.addEventListener("click", function () { 
			qualificationSection.classList.toggle("d-none");
			if(document.querySelector(".add-new-qualification .course-name")) {
				document.querySelector(".add-new-qualification .course-name").value = '';
			}
			if(document.querySelector(".add-new-qualification .course-place")) {
				document.querySelector(".add-new-qualification .course-place").value = '';
			}				
			if(document.querySelector(".add-new-qualification .course-year")) {
				document.querySelector(".add-new-qualification .course-year").value = '';
			}
		});
  
		// Add new qualification
		inlineAddButton?.addEventListener("click", function () {
			const nameInput = qualificationSection.querySelector("#new-qualification-name");
			const universityInput =	qualificationSection.querySelector("#new-university");
			const yearInput = qualificationSection.querySelector("#new-completion-year");
			
			const name = nameInput.value.trim();
			const university = universityInput.value.trim();
			const year = yearInput.value.trim();
	
			if (!name || !university || !year) {
				alert("Please fill in all fields.");
				return;
			}

			// Create new item
			const newItem = document.createElement("div");
			newItem.className =
			"my-qualifications-item d-flex justify-content-between align-items-center";
			newItem.innerHTML = `
			<div class="my-qualifications-item-wrap d-flex justify-content-between align-items-center">
				<div class="form-element">
					<label for="qualification-name">Qualification name</label>
					<input type="text" class="course-name" name="qualification-name[]" value="${name}">
				</div>
				<div class="place-year-wrap d-flex">
					<div class="form-element form-element--half">
							<label for="university">Place of completion</label>
							<input type="text" class="course-place" name="university[]" value="${university}">
					</div>
					<div class="form-element form-element--half">
							<label for="completion-year">Year of completion</label>
							<input type="text" class="course-year" name="completion-year[]" value="${year}">
					</div>
				</div>
			</div>
			<button type="button" class="btn btn-delete"><span class="icon icon-delete"></span></button>
			`;
	
			// Insert the new qualification above the "Add new" toggle button
			qualificationGroup.insertBefore(newItem, addQualificationBtn);
	
			// Show the "Add new" toggle button
			addQualificationBtn.classList.remove("d-none");
	
			// Clear and hide the input section
			nameInput.value = "";
			universityInput.value = "";
			yearInput.value = "";
			qualificationSection.classList.add("d-none");
	
		});
  
		// Delete functionality
		document.body.addEventListener("click", function(e) {
			const btn = e.target.closest(".btn-delete");
			if (!btn) return;

			const item = btn.closest(".my-qualifications-item");
			if (!item) return;

			const name = item.querySelector('input[name="qualification-name[]"]').value.trim();
			const university = item.querySelector('input[name="university[]"]').value.trim();
			const year = item.querySelector('input[name="completion-year[]"]').value.trim();

			const entryToRemove = `qualificationName:${name},placeOfCompletion:${university},yearOfCompletion:${year}`;

			const qualificationInput = document.getElementById('employee-qualification');
			if (qualificationInput && qualificationInput.value.trim() !== "") {
				const updatedEntries = qualificationInput.value
				.trim()
				.split(";")
				.filter(entry => entry.trim() !== entryToRemove);

				qualificationInput.value = updatedEntries.join(";");
			}

			item.remove();

			const remaining = document.querySelectorAll(".my-qualifications-item");
			if (remaining.length === 0) {
				// qualificationSection.classList.remove("d-none");
			}
		});

  	}
});